const codePostal = [
  //1:Antananarivo
  { id: 1, ville: "Antananarivo", code: 101, region: "1" },
  { id: 2, ville: "Antananarivo", code: 102, region: "1" },
  { id: 3, ville: "Antananarivo", code: 103, region: "1" },
  { id: 4, ville: "Ambohidratrimo", code: 105, region: "1" },
  { id: 5, ville: "Andramasina", code: 106, region: "1" },
  { id: 6, ville: "Anjozorobe", code: 107, region: "1" },
  { id: 7, ville: "Ankazobe", code: 108, region: "1" },
  { id: 8, ville: "Antananarivo Nord", code: 103, region: "1" },
  { id: 9, ville: "Antananarivo Sud", code: 102, region: "1" },
  { id: 10, ville: "Manjakandriana", code: 116, region: "1" },
  { id: 11, ville: "Fenoarivo Centre", code: 115, region: "1" },
  { id: 12, ville: "Tsiroanomandidy", code: 112, region: "1" },
  { id: 13, ville: "Arivonimamo", code: 119, region: "1" },
  { id: 14, ville: "Miarinarivo", code: 117, region: "1" },
  { id: 15, ville: "Soavinandriana", code: 118, region: "1" },
  { id: 16, ville: "Ambatolampy", code: 104, region: "1" },
  { id: 17, ville: "Antanifotsy", code: 109, region: "1" },
  { id: 18, ville: "Antsirabe Rural", code: 111, region: "1" },
  { id: 19, ville: "Antsirabe Urban", code: 110, region: "1" },
  { id: 20, ville: "Betafo", code: 113, region: "1" },
  { id: 21, ville: "Faratsiho", code: 114, region: "1" },

  //2:Antsiranana
  { id: 22, ville: "Ambanja", code: 203, region: "2" },
  { id: 23, ville: "Ambilobe", code: 204, region: "2" },
  { id: 24, ville: "Antsiranana Rural", code: 202, region: "2" },
  { id: 25, ville: "Antsiranana Urban", code: 201, region: "2" },
  { id: 26, ville: "Nosy be", code: 207, region: "2" },
  { id: 27, ville: "Andapa", code: 205, region: "2" },
  { id: 28, ville: "Antalaha", code: 206, region: "2" },
  { id: 29, ville: "Sambava", code: 208, region: "2" },
  { id: 30, ville: "Vohimarina(Iharana)", code: 209, region: "2" },

  //3:Fianarantsoa
  { id: 31, ville: "Ambatonfinandrahana", code: 304, region: "3" },
  { id: 32, ville: "Ambositra", code: 306, region: "3" },
  { id: 33, ville: "Fandriana", code: 308, region: "3" },
  { id: 34, ville: "Mandriana", code: 323, region: "3" },
  { id: 35, ville: "Befotaka", code: 307, region: "3" },
  { id: 36, ville: "Farafangana", code: 309, region: "3" },
  { id: 37, ville: "Midongy Sud", code: 318, region: "3" },
  { id: 38, ville: "Vangaindrano", code: 320, region: "3" },
  { id: 39, ville: "Vondrozo", code: 322, region: "3" },
  { id: 40, ville: "Ambalavao", code: 303, region: "3" },
  { id: 41, ville: "Ambohimasoa", code: 305, region: "3" },
  { id: 42, ville: "Fianarantsoa Rural", code: 302, region: "3" },
  { id: 43, ville: "Fianarantsoa Urban", code: 301, region: "3" },
  { id: 44, ville: "Ikalamavony", code: 314, region: "3" },
  { id: 45, ville: "Iakora", code: 311, region: "3" },
  { id: 46, ville: "Ihosy", code: 313, region: "3" },
  { id: 47, ville: "Ivohibe", code: 315, region: "3" },
  { id: 48, ville: "Ifanadiana", code: 312, region: "3" },
  { id: 49, ville: "Ikongo", code: 310, region: "3" },
  { id: 50, ville: "Manakara Sud", code: 316, region: "3" },
  { id: 51, ville: "Mananjary", code: 317, region: "3" },
  { id: 52, ville: "Nosy Varika", code: 319, region: "3" },
  { id: 53, ville: "Vohipeno", code: 321, region: "3" },

  //4:Mahajanga
  { id: 58, ville: "Antsanitia", code: 402, region: "4" },
  { id: 59, ville: "Sambaina", code: 401, region: "4" },
  { id: 60, ville: "Katsepy", code: 402, region: "4" },
  { id: 61, ville: "Marovoay", code: 402, region: "4" },
  { id: 62, ville: "Mampikony", code: 403, region: "4" },
  { id: 63, ville: "Amborovy", code: 401, region: "4" },
  { id: 64, ville: "Maevatanana", code: 411, region: "4" },
  { id: 65, ville: "Ampahiliana", code: 411, region: "4" },
  { id: 66, ville: "Ankazobe", code: 411, region: "4" },
  { id: 67, ville: "Ambatolahy", code: 411, region: "4" },
  { id: 68, ville: "Antanifotsy", code: 412, region: "4" },
  { id: 69, ville: "Tsiroanomandidy", code: 412, region: "4" },
  { id: 70, ville: "Antsohihy (centre-ville)", code: 415, region: "4" },
  { id: 72, ville: "Ambalavato", code: 415, region: "4" },
  { id: 73, ville: "Mandritsara", code: 415, region: "4" },
  { id: 74, ville: "Boriziny", code: 415, region: "4" },

  //5:Toamasina
  { id: 76, ville: "Ambatondrazaka", code: 503, region: "5" },
  { id: 77, ville: "Amparafaravola", code: 504, region: "5" },
  { id: 78, ville: "Andilamena", code: 505, region: "5" },
  { id: 79, ville: "Anosibe", code: 506, region: "5" },
  { id: 80, ville: "Moramanga", code: 514, region: "5" },
  { id: 81, ville: "Fenoarivo Atsinanana", code: 509, region: "5" },
  { id: 82, ville: "Mananara", code: 511, region: "5" },
  { id: 83, ville: "Maroantsetra", code: 512, region: "5" },
  { id: 84, ville: "Nosy-Boraha (Ste Marie)", code: 515, region: "5" },
  { id: 85, ville: "Soanierana-Ivongo", code: 516, region: "5" },
  { id: 86, ville: "Vavatenina", code: 518, region: "5" },
  { id: 87, ville: "Ampasimanolotra", code: 508, region: "5" },
  { id: 88, ville: "Antanambao Manampotsy", code: 507, region: "5" },
  { id: 89, ville: "Mahanoro", code: 507, region: "5" },
  { id: 90, ville: "Marolambo", code: 513, region: "5" },
  { id: 91, ville: "Toamasina Rural", code: 502, region: "5" },
  { id: 92, ville: "Toamasina Urban", code: 501, region: "5" },
  { id: 93, ville: "Vatomandry", code: 517, region: "5" },

  //6:Toliary
  { id: 94, ville: "Ambovombe-Androy", code: 604, region: "6" },
  { id: 95, ville: "Bekily", code: 607, region: "6" },
  { id: 96, ville: "Beloha", code: 609, region: "6" },
  { id: 97, ville: "Tsiombe", code: 621, region: "6" },
  { id: 98, ville: "Amboasary Sud", code: 603, region: "6" },
  { id: 99, ville: "Betroka", code: 613, region: "6" },
  { id: 100, ville: "Taolagnaro", code: 614, region: "6" },
  { id: 101, ville: "Ampanihy", code: 605, region: "6" },
  { id: 102, ville: "Ankazoabo Sud", code: 606, region: "6" },
  { id: 103, ville: "Benenitra", code: 610, region: "6" },
  { id: 104, ville: "Beroroha", code: 611, region: "6" },
  { id: 105, ville: "Betioky Sud", code: 612, region: "6" },
  { id: 106, ville: "Morombe", code: 618, region: "6" },
  { id: 107, ville: "Sakaraha", code: 620, region: "6" },
  { id: 108, ville: "Toliara Rural", code: 602, region: "6" },
  { id: 109, ville: "Toliara Urban", code: 601, region: "6" },
  { id: 110, ville: "Belon-i Tsiribihana", code: 608, region: "6" },
  { id: 112, ville: "Manja", code: 616, region: "6" },
  { id: 113, ville: "Miandrivazo", code: 617, region: "6" },
  { id: 114, ville: "Morondava", code: 619, region: "6" },
];

export default codePostal;
